"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConfigWithSettings = void 0;
var tslib_1 = require("tslib");
/**
 * @internal
 */
function updateConfigWithSettings(config, settings) {
    var updatedConfig = config;
    if (settings) {
        if (settings["disableKpiDashboardHeadlineUnderline"] === true) {
            updatedConfig = tslib_1.__assign(tslib_1.__assign({}, updatedConfig), { disableDrillUnderline: true });
        }
        if (settings["enableKDWidgetCustomHeight"] === true) {
            updatedConfig = tslib_1.__assign(tslib_1.__assign({}, updatedConfig), { enableCompactSize: true });
        }
    }
    return updatedConfig;
}
exports.updateConfigWithSettings = updateConfigWithSettings;
//# sourceMappingURL=chartOptionsForSettings.js.map